import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CommonApiService } from '../common-api.service';
import { Country } from './country.model';
import { map } from 'rxjs/operators';

export interface CountriesResponse {
  payload: Country[];
}

@Injectable({
  providedIn: 'root',
})
export class CountryService {
  constructor(private http: HttpClient, private commonApiService: CommonApiService) {}

  getCountries() {
    return this.findAllCountries();
  }

  findAllCountries() {
    return this.http.get<CountriesResponse>(this.commonApiService.getUrl('countries')).pipe(map(res => res.payload));
  }
}
